import * as React from 'react';
import styled from 'styled-components';

type BulkActionMenuProps = {
  NumSelected: number;
  children?: React.ReactNode;
  ClearSelectionHandler: (event: React.MouseEvent<HTMLElement>) => void;
};

const StyledWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  position: absolute;
  width: 80%;
  height: 64;
  bottom: 30px;
  left: 50%;
  transform: translate(-50%, 0%);
  padding: 15px 15px 15px 15px;
  margin: 30px 0px 30px 0px;
  margin-left: auto;
  margin-right: auto;
  gap: 8px;
  border-radius: 4px 0px 0px 0px;
  opacity: 0px;
  border: 1px solid #eeeeee;
  box-shadow: 0px 9px 28px 8px #0000000d;

  box-shadow: 0px 6px 16px 0px #00000014;

  box-shadow: 0px 3px 6px -4px #0000001f;
  background-color: white;
`;

const FlexRightContainer = styled.div`
  display: inline-flex;
  flex-direction: row-reverse;
  float: right;
  width: fill-available;
`;

const LinkButton = styled.a`
  padding: 0px 15px 0 px 15px;
`;
const StyledSpan = styled.span`
  min-width: fit-content;
`;

const BulkActionMenu: React.FC<BulkActionMenuProps> = props => {
  const { children, NumSelected, ClearSelectionHandler } = props;
  return (
    <StyledWrapper key="bulkActionMenu" onClick={e => e.stopPropagation()}>
      <StyledSpan key="bulkNumSelected">{NumSelected} selected</StyledSpan>
      <StyledSpan key="bulkClearLink">
        <a onClick={ClearSelectionHandler}>Clear Selection</a>
      </StyledSpan>
      <FlexRightContainer key="bulkChildren">{children}</FlexRightContainer>
    </StyledWrapper>
  );
};

export default BulkActionMenu;
